import { createPortal } from 'react-dom';

export const RootPortal = ({ children }) => {
  return createPortal(children, document.getElementById('root'));
};
